module.exports = __webpack_public_path__ + "img/30n.b18b8e23.png";